module.exports = __webpack_public_path__ + "media/images/athletes/1350-005013a06243fa8e025a9cb448cc1f66.png";